/* eslint-disable no-template-curly-in-string */
var es = {
    translation: {
        button: {
            backToAccountManager: 'Regresar al Administrador de Cuenta'
        },
        labels: {
            title: 'TODO'
        },
        errorPage: {
            title: 'TODO',
            description: 'Tenemos problemas para recuperar\nsu información',
            tryAgain: 'Por favor, vuelva a intentarlo más tarde.',
            noCertificates: 'No hay certificados que coincidan con ese número de certificado.\nPor favor verifique el número e inténtelo de nuevo.'
        },
        faqs: {
            faqLinkText: 'Preguntas Frecuentes sobre Recompensas',
            description: '*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.',
            cathaySnapshotDescription: '*Compras sujetas a aprobación de crédito. Vea los <a>Términos de Recompensas de Crédito</a> para detalles.',
            suncountrySnapshotDescription: '*Vea los <a>Términos de Recompensas de Crédito</a> para detalles.',
            verizonSnapshotDescription: 'Excluye pagos de facturas. \n*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.',
            jcrewFaqsSubHeader: 'Vea su <a>Nivel de Estatus de Categoría de J.Crew y todos los beneficios para titulares de tarjetas</a>',
            virginDescription: '*Vea los <a>Términos de Recompensas de Crédito</a> para detalles.\n\nSi tiene una devolución en su Tarjeta de Virgin Red Rewards, es posible que vea puntos negativos en una o más categorías. Los nuevos puntos que obtenga con su tarjeta en esa categoría se aplicarán primero al saldo negativo de la misma categoría. Los puntos se añadirán a su Cuenta del Programa de Virgin Red Rewards una vez que su saldo de puntos dentro de esa categoría sea positivo.\n\nSynchrony Bank emite esta tarjeta conforme una licencia de MasterCard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca comercial de Mastercard International Incorporated. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC y usada con su autorización.',
            cathayDescription: '*Compras sujetas a aprobación de crédito. Vea los <a>Términos de Recompensas de Crédito</a> para detalles.\n\nSynchrony Bank emite esta tarjeta conforme una licencia de MasterCard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca comercial de Mastercard International Incorporated. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC y usada con su autorización.',
            verizonDescription: 'Excluye pagos de facturas. \n\n*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.\n\nLa Tarjeta Verizon Visa® es emitida por Synchrony Bank conforme a una licencia de Visa U.S.A., Inc. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC, y usada con su autorización.',
            suncountryDescription: '*Vea los <a>Términos de Recompensas de Crédito</a> para detalles.\n\nNota: Las devoluciones pueden generar un saldo negativo de puntos. Los puntos nuevos obtenidos se aplicarán a dicho saldo.\n\n La Tarjeta Sun Country Airlines Visa Signature es emitida por Synchrony Bank conforme a una licencia de Visa U.S.A., Inc. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC, y usada con su autorización.',
            jcpenneyDescription: '*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.',
            walgreensDescription: '*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.\n\nSynchrony Bank emite esta tarjeta conforme una licencia de MasterCard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca comercial de Mastercard International Incorporated. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC y usada con su autorización.'
        },
        certificateHistoryTab: {
            amount: 'Monto del \nCertificado',
            certificate: 'Certificado',
            status: 'Estatus',
            certificateNumber: 'Número de Certificado',
            date: 'Fecha',
            searchCertNum: 'Buscar el Número de Certificado',
            redeemed: 'Canjeado',
            expired: 'Expirado'
        },
        selectDropdown: {
            sortBy: 'Organizar Por',
            newestDate: 'Fecha - Más reciente',
            oldestDate: 'Fecha - Más antigua',
            redeemedStatus: 'Estatus - Canjeado',
            expiredStatus: 'Estatus - Vencido',
            lowestAmount: 'Monto - Más bajo',
            highestAmount: 'Monto - Más alto'
        },
        fullDetailsPage: {
            certificateHistory: 'Historial de Certificados',
            myRewardsMilestones: 'Hitos de Mis Recompensas',
            yourRewardsMilestones: 'Sus Hitos de Recompensas',
            howToEarnPointsHeader: 'Cómo obtener puntos',
            jCrewHowToEarnPointsHeader: 'Cómo obtener puntos por compras en J.Crew y J.Crew Factory',
            virginHowToEarnPointsHeader: 'Cómo obtener puntos*',
            cathayHowToEarnPointsHeader: 'Cómo obtener Asia Miles*',
            sunCountryHowToEarnPointsHeader: 'Sus ganancias de Sun Country',
            verizonHowToEarnPointsHeader: 'Cómo obtener Verizon Dollars',
            exclusionsApply: 'Se aplican exclusiones',
            certificate: {
                expiringSoon: 'CADUCA PRONTO',
                select: 'SELECCIONE',
                useBy: 'Usar antes del'
            },
            athome: {
                DUAL_CARD: {
                    redemptionDisclaimer: 'Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su tarjeta At Home Insider Perks® Mastercard® para obtener puntos para su próximo certificado.',
                    legalInformation: 'Las tarjetas At Home Insider Perks® Mastercard y At Home Insider Perks® Boss Mastercard son emitidas por Synchrony Bank en conformidad con una licencia de Mastercard International Incorporated. Mastercard y el diseño de los círculos son marcas registradas de Mastercard International Incorporated.'
                },
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su tarjeta At Home Insider Perks® Credit Card para obtener puntos para su próximo certificado.'
                },
                totalPointsSavedYTD: 'AHORRO TOTAL EN CERTIFICADOS DE RECOMPENSA CANJEADOS ESTE AÑO',
                totalPointsRedeemedYTD: 'TOTAL DE PUNTOS UTILIZADOS PARA CERTIFICADOS DE RECOMPENSAS ESTE AÑO',
                // eslint-disable-next-line sonarjs/no-duplicate-string
                totalPointsEarnedYTD: 'PUNTOS TOTALES OBTENIDOS ESTE AÑO',
                printCheckoutModal: 'Simplemente imprima o muestre los Certificados de Recompensas digitales a un asociado o ingrese el código en línea al momento de pagar.*'
            },
            tjx: {
                DUAL_CARD: {
                    redemptionDisclaimer: 'Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su tarjeta de crédito TJX Rewards para obtener puntos para su próximo certificado.'
                },
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su tarjeta de crédito TJX Rewards para obtener puntos para su próximo certificado.'
                },
                totalPointsSavedYTD: 'TOTAL AHORRADO ESTE AÑO EN RECOMPENSAS',
                totalPointsRedeemedYTD: 'PUNTOS TOTALES CANJEADOS ESTE AÑO',
                totalPointsEarnedYTD: 'PUNTOS TOTALES OBTENIDOS ESTE AÑO',
                printCheckoutModal: 'Simplemente imprima o muestre los Certificados de Recompensas digitales al momento de pagar.'
            },
            hft: {
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su Tarjeta de Crédito Harbor Freight Tools para obtener puntos para su próximo certificado.'
                },
                totalPointsSavedYTD: 'AHORRO TOTAL EN CERTIFICADOS DE RECOMPENSA CANJEADOS ESTE AÑO',
                totalPointsRedeemedYTD: 'TOTAL DE PUNTOS UTILIZADOS PARA CERTIFICADOS DE RECOMPENSAS ESTE AÑO',
                totalPointsEarnedYTD: 'PUNTOS TOTALES OBTENIDOS ESTE AÑO',
                printCheckoutModal: 'Simplemente imprima o muestre los Certificados de Recompensas digitales a un asociado o ingrese el código en línea al momento de pagar.*'
            },
            removeTimeFromList: 'Puede que se demore hasta 72 horas para ser removidos de esta lista.',
            rewards: 'Recompensas',
            printCheckout: 'Simplemente imprima o muestre los Certificados de Recompensas digitales al momento de pagar',
            useRewardsNow: 'Canjee sus Certificados de Recompensas',
            print: 'imprimir',
            selectAll: 'SELECCIONAR TODO',
            unSelectAll: 'DESELECCIONAR TODOS',
            myRewardsCertificates: 'Mis Certificados de Recompensas',
            yourRewardsCertificates: 'Sus Certificados de Recompensas',
            viewAllCertificates: 'VER TODOS LOS CERTIFICADOS DE RECOMPENSAS',
            viewPrint: 'VER/IMPRIMIR',
            viewRewardCertificates: 'Ver Certificados de Recompensas'
        },
        earnings: {
            earningsFromLastStatement: 'Sus ganancias de su último estado de cuenta'
        },
        cathayEarnings: {
            yourCathayEarnings: 'Sus Cathay Asia Miles obtenidas'
        },
        jCrewEarnings: {
            noAdjustments: 'Actualmente no hay ajustes en sus Recompensas J.Crew',
            yourJcrewEarnings: 'Sus ganancias con de J.Crew Passport'
        },
        sunCountryEarnings: {
            yourSunCountryEarnings: 'Sus ganancias de Sun Country'
        },
        verizonEarnings: {
            yourVerizonEarnings: 'Sus ganancias de Verizon',
            verizonEarningsSubtitle: 'Obtenga hasta un 4% en todas sus compras favoritas con su Tarjeta Verizon Visa®*'
        },
        virginEarnings: {
            yourVirginEarnings: 'Sus ganancias Virgin Red'
        },
        jcrew: {
            perks: {
                perksHeader: 'Algunas ventajas especiales para los titulares de tarjetas',
                freeStandardShippingTitle: 'ENVÍO GRATIS',
                freeStandardShippingDescription: 'Envío estándar gratuito en J.Crew y J.Crew Factory',
                birthdaySurprisesTitle: 'CUMPLEAÑOS',
                birthdaySurprisesDescription: '$25 para gastar en J.Crew y J.Crew Factory',
                bonusPointsDaysTitle: 'ALTERACIONES ESTÁNDAR GRATUITAS',
                bonusPointsDaysDescription: 'En productos de precio sin descuento en J.Crew'
            }
        },
        virgin: {
            perks: {
                perksHeader: 'Algunos beneficios especiales para los titulares de tarjetas*',
                extraNightTitle: 'OBTENGA UNA NOCHE ADICIONAL GRATIS',
                extraNightDescription: 'Compre dos noches y obtenga una gratis de Virgin Hotels por año',
                flyAndEarnTitle: 'VUELE CON NOSOTROS Y OBTENGA PUNTOS',
                flyAndEarnDescription: 'Reciba 25 Puntos de Nivel por gastar $2,500 por mes, con un máximo de 50 por mes.',
                earnBonusPointsTitle: 'OBTENGA PUNTOS EXTRA',
                earnBonusPointsDescription: 'Obtenga 2,500 puntos adicionales por añadir hasta 4 Usuarios Autorizados.'
            }
        },
        suncountry: {
            perks: {
                perksHeader: 'Algunos beneficios especiales para los titulares de tarjetas',
                earnOffOnSuitcaseTitle: '50% DE DESCUENTO EN LA PRIMERA BOLSA',
                earnOffOnSuitcaseDescription: 'Ahorre 50% en las primeras bolsas para usted y sus acompañantes viajando en su mismo itinerario.',
                flyAndEarnTitle: '50% DE DESCUENTO EN LA SELECCIÓN DE ASIENTOS',
                flyAndEarnDescription: 'Ahorre 50% en su selección de asientos para que su vuelo sea mas cómodo.',
                earnBonusPointsTitle: 'BONIFICACIÓN DE ANIVERSARIO',
                earnBonusPointsDescription: 'Obtenga 10,000 puntos de bonificación cuando gaste $10,000+ anuales.'
            }
        },
        mocks: {
            accountEnding: 'Cuenta que termina en {{accountLast4}}',
            availableToSpend: 'Disponible para gastar',
            cardAccountEnding: 'Tarjeta para cuenta que termina en {{accountLast4}}',
            currentBalance: 'Saldo Actual',
            environment: 'Elige un entorno',
            makeAPayment: 'Realizar un pago',
            paymentDueDate: 'Fecha de vencimiento del pago',
            rewards: 'RECOMPENSAS',
            totalMinimumPayment: 'Pago Mínimo Total',
            rewardsFooterButton: 'VER LOS DETALLES COMPLETOS DE LAS RECOMPENSAS'
        },
        modal: {
            modalTitle: 'Descripción de las Recompensas',
            rewardsFooter: 'VER LOS DETALLES COMPLETOS DE LAS RECOMPENSAS',
            header: {
                text: 'Descripción de las Recompensas'
            },
            footer: {
                closeButton: 'Cerrar'
            },
            rewards: {
                currentPoints: 'Puntos actuales',
                earned: 'Sus Recompensas obtenidas',
                nextCertificate: 'certificado de ${{amount}}',
                currentRewards: 'Saldo actual del\nCertificado de Recompensas',
                myProgress: 'Progreso de Mis Recompensas',
                yourProgress: 'Progreso de sus Recompensas'
            }
        },
        shopMore: {
            earnPoints: {
                default: 'Una vez cajeado el Certificado de Recompensas, se mostrará aquí.',
                aeoutfitters: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                athome: 'Obtenga puntos para su próximo Certificado de Recompensas y luego vuelva a consultar aquí para canjearlos.',
                cathay: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                jcpenney: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                jcrew: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                suncountry: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                tjx: 'Siga comprando con su tarjeta de crédito TJX Rewards para obtener puntos para su próximo Certificado de Recompensas. ¡Es la única forma de ahorrar aún más en sus tiendas favoritas!',
                virgin: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                onepaywalmart: "Consulte nuestros beneficios especiales.",
                dicks: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                verizon: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                walgreens: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas.",
                hft: 'Obtenga puntos para su próximo Certificado de Recompensas y luego vuelva a consultar aquí para canjearlos.'
            },
            cathayButtonText: 'Ir a Cathay Rewards',
            jCrewButtonText: 'Ir a Recompensas J.Crew',
            suncountryButtonText: 'IR A SUN COUNTRY REWARDS',
            verizonButtonText: 'IR A RECOMPENSAS DE VERIZON',
            virginButtonText: 'Aprenda más',
            walgreensButtonText: 'IR A MYWALGREENS REWARDS',
            earnMoreRewards: 'Gane más recompensas',
            withYour: 'con su',
            onepaywalmartPlccText: '¡Vea sus recompensas disponibles hoy!'
        },
        drawerHeader: {
            subtitle: {
                account: 'Cuenta que termina en {{accountLast4}}'
            }
        },
        drawerActionButton: {
            aeoutfittersDrawerActionButtonText: 'IR A REAL REWARDS',
            jcpenneyDrawerActionButtonText: 'IR A JCPENNEY REWARDS',
            onepaywalmartDrawerActionButtonText: 'IR A ONEPAY REWARDS',
            dicksDrawerActionButtonText: 'IR A SCOREREWARDS'
        },
        error: {
            uiComponent: 'No disponible'
        },
        rewardsBanner: {
            altText: 'banner de {{client}}'
        },
        viewPrintModal: {
            and: 'y',
            atHomeViewPrint: 'Los certificados se pueden utilizar en la tienda o en línea en',
            digitalCopy: 'Esta es una copia digital del certificado que recibió con el estado de cuenta de su tarjeta de crédito.',
            issueDate: 'Fecha de Emisión',
            presentPurchase: '*Presente al momento de la compra.',
            tjxDisclaimer: 'No aceptado en Marshalls o HomeSense en Canadá.',
            athomeDisclaimer: 'Puede que se demore hasta 72 horas para remover los Certificados de Recompensas canjeados de esta lista.',
            tjxViewPrint: 'Los certificados se pueden usar como efectivo dentro de nuestra familia de tiendas o en línea en',
            hftViewPrint: 'Los certificados se pueden utilizar dentro de nuestras tiendas o en línea en',
            redeemAt: '<p>Canjee en:</p>',
            rewardsCertificate: 'Certificado de Recompensas',
            viewRewardCertificate: 'Ver Certificados de Recompensas',
            viewRewardsProgram: 'Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles',
            hftDisclaimer: 'Puede que se demore hasta 72 horas para remover los Certificados de Recompensas canjeados de esta lista.'
        }
    }
};
export default es;
